module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-00.2.65321d78.jpg";